import React from 'react';
import ProductCardQuickSearch from '../ProductCards/ProductCardQuickSearch';
import QuickSearchLinkItem from './QuickSearch.LinkItem';
import { SearchItem } from '../../Types/SearchItem';
import clsx from 'clsx';
import ProductCard from '../ProductCards/ProductCard';

interface QuickSearchResultTabProps {
  modelKey: string;
  results: SearchItem[];
}

const QuickSearchResultItem = ({
  modelKey,
  item,
}: {
  modelKey: string;
  item: SearchItem;
}) => {
  switch (modelKey) {
    case 'products':
      return <ProductCard product={item} />;
    default:
      return <QuickSearchLinkItem name={item.name} url={item.url} />;
  }
};

const QuickSearchResultTab = ({
  modelKey,
  results,
}: QuickSearchResultTabProps) => {
  return (
    <div
      id={`quick-search__tab-${modelKey}`}
      className={clsx(
        'mt-4 grid auto-rows-min grid-cols-1 gap-4 pb-44 lg:mt-6 lg:h-auto lg:pb-16',
        modelKey === 'products'
          ? 'grid-cols-2 md:grid-cols-4 xl:grid-cols-6'
          : 'grid-cols-1 gap-1 lg:grid-cols-4 lg:gap-x-4 lg:gap-y-2'
      )}
    >
      {results.map((result, index) => (
        <QuickSearchResultItem
          key={index}
          modelKey={modelKey}
          item={result}
        />
      ))}
    </div>
  );
};

export default QuickSearchResultTab;
